<template>
    <div class="subtitle-cue-textarea">
        <div class="form-group"
             :class="{ 'has-warning': validation.warning && !hideWarnings, 'has-error': validation.error }">
            <textarea class="form-control"
                      style="font-size: 10pt; overflow:auto;"
                      wrap="off"
                      rows="3"
                      dir="auto"
                      ref="translation"
                      v-html="lines"
                      @keydown="preventTooManyLines"
                      :name="name"
                      :readonly="disabled"
                      :tabindex="tabindex"
                      :required="required"
                      @keyup="emitValueUpdated"
                      @blur="emitValueUpdated"
            ></textarea>

            <span class="help-block" v-if="validation.errors.empty">
                This cannot be empty!
            </span>
            <span class="help-block" v-if="validation.errors.lines">
                You can only use maximum three lines.
            </span>
            <span class="help-block" v-if="validation.warnings.length && !hideWarnings">
                Lines should not be longer than 40 characters. Try using multiple lines.
            </span>
            <span class="help-block" v-if="validation.warnings.lines && !hideWarnings">
                Try to use only two lines.
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            required: {
                default: false
            },
            lines: String,
            disabled: {
                default: false
            },
            hideWarnings: {
                default: false
            },
            name: {
                default: null
            }
        },

        data: function () {
            return {
                validation: this.initState(),
            };
        },

        computed: {
            tabindex() {
                return this.disabled ? -1 : 1;
            },

            isValid() {
                return !this.validation.errors.empty && !this.validation.errors.lines;
            }
        },

        mounted() {
            this.validate();
        },

        methods: {
            preventTooManyLines: function (e) {
                let numLines = this.$refs.translation.value.split('\n').length;

                if (e.keyCode === 13 && numLines >= 3) {
                    e.preventDefault();
                    return false;
                }
            },
            initState: function () {
                return {
                    error: false,
                    warning: false,
                    errors: {
                        empty: false,
                        lines: false,
                    },
                    warnings: {
                        length: false,
                        lines: false,
                    }
                };
            },

            emitValueUpdated: function (value) {
                this.validate();
                this.$emit('subtitleCueTextAreaUpdated', this.$refs.translation.value);
            },

            validate() {
                let value = this.$refs.translation.value;
                let numberOfLines = value.split('\n').length;
                let numberOfTimmedLines = value.trim().split('\n').length;

                this.validation = this.initState();

                let $this = this;
                value.split('\n').forEach(function (item) {
                    if (item.length > 40) {
                        $this.validation.warning = true;
                        $this.validation.warnings.length = true;
                    }
                });

                if (value.trim().length === 0) {
                    this.validation.error = true;
                    this.validation.errors.empty = true;
                }

                if (numberOfTimmedLines === 3) {
                    this.validation.warning = true;
                    this.validation.warnings.lines = true;
                } else if (numberOfLines > 3) {
                    this.validation.error = true;
                    this.validation.errors.lines = true;
                }
            }
        }
    };
</script>

<style>
    .subtitle-cue-textarea {

    textarea {
        white-space: pre;
    }

    }
</style>
